__turbopack_context__.v({
  "dark": "WidgetPane-module-scss-module__lZsujq__dark",
  "widgetCloseBtn": "WidgetPane-module-scss-module__lZsujq__widgetCloseBtn",
  "widgetPane": "WidgetPane-module-scss-module__lZsujq__widgetPane",
  "widgetPaneContent": "WidgetPane-module-scss-module__lZsujq__widgetPaneContent",
  "widgetPaneHeader": "WidgetPane-module-scss-module__lZsujq__widgetPaneHeader",
  "widgetPaneOpen": "WidgetPane-module-scss-module__lZsujq__widgetPaneOpen",
});
